import UIComponent from "../../common/UIComponent";
import "./index.css";

/**
 * @description 点播总时长 - UI控件
 *
 */
export default class H5Duration extends UIComponent {
  constructor(elementId, interfaces) {
    super(interfaces);
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.init();
    this.interfaces.on(VhallPlayer.LOADEDMETADATA, () => {
      let timer = setInterval(() => {
        const duration = this.interfaces.getDuration();
        // 在移动端存在duration=Infinity的情况
        if (duration !== 0 && isFinite(duration)) {
          clearInterval(timer);
          this.h5duration.innerText = this._secondToDate(duration);
        }
      }, 1000)
    })
  }

  init() {
    // 分割线
    this.cutLine = document.createElement("i");
    this.cutLine.innerText = "/";
    if(this.theme) {
      this.insertElement(this.elementId, this.cutLine);
    }

    this.h5duration = document.createElement("span");
    this.h5duration.setAttribute("class", "vhallPlayerh5-duration");
    this.h5duration.innerText = "00:00:00";
    this.insertElement(this.elementId, this.h5duration);
  }

  // _secondToDate(result) {
  //   var h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
  //   var m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
  //   var s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
  //   return result = (Number(m) + Number(h * 60)) + ":" + s;
  // }

  _secondToDate(result) {
    var h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
    var m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
    var s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
    return result = h + ":" + m + ":" + s;
  }

}